<template>
  <div>
    <el-button type="primary" class="addBtn" @click="addBtnClick"
      >新增轮播图</el-button
    >
    <div class="table-wrap">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="sort" label="权重" align="center" width="120">
        </el-table-column>

        <el-table-column label="pc端图片" align="center">
          <template slot-scope="scope">
            <img
              :src="imgDomain + scope.row.carousel_img"
              class="carousel-img"
            />
          </template>
        </el-table-column>
				<el-table-column label="h5端图片" align="center">
          <template slot-scope="scope">
            <img
              :src="imgDomain + scope.row.h5_carousel_img"
              class="carousel-img"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <div class="operation-wrap">
              <span class="opration-item" @click="editServiceClick(scope.row)"
                >编辑</span
              >
              <span class="opration-item" @click="deleteServiceClick(scope.row)"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <common-dialog
      title="删除轮播图"
      :dialogVisible="dialogVisible"
      @cancel="dialogCancelClick"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div class="dialog-body-wrap">
        是否删除轮播图？
      </div>
    </common-dialog>
  </div>
</template>

<script>
import { carouselList, deleteCarousel } from "@/api/carousel-manage";
import { mapState } from "vuex";
import CommonDialog from "@/components/CommonDialog";

export default {
  name: "slideimgmanage",
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      handle_row: {},
    };
  },
  computed: {
    ...mapState(["imgDomain"]),
  },
  mounted() {
    this.getCarouselList();
  },
  components: {
    CommonDialog,
  },
  methods: {
    addBtnClick() {
      if (this.tableData.length < 6) {
        this.$router.push("/slideimg-manage/add-slide-img");
      } else {
        this.$message({
          type: "warning",
          message: "轮播图已达上限（6张）, 无法再添加",
        });
      }
    },
    async getCarouselList() {
      const { data, status } = await carouselList();
      console.log(data, "轮播图数据");
      if (status !== 200) return;
      this.tableData = data.data;
    },
    deleteServiceClick(row) {
      this.handle_row = row;
      this.dialogVisible = true;
    },
    dialogCancelClick() {
      this.dialogVisible = false;
    },
    dialogClose() {
      this.getCarouselList();
    },
    async dialogConfirmClick() {
      const { status } = await deleteCarousel(this.handle_row.id);
      if (status !== 200) return;
      this.dialogVisible = false;
    },
    editServiceClick(row) {
      this.$router.push({
        path: "/slideimg-manage/edit-slide-img",
        query: {
          uuid: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";

.addBtn {
  float: right;
  margin-bottom: 30px;
}
.table-wrap {
  margin-bottom: 40px;
  .carousel-img {
    max-width: 400px;
    max-height: 300px;
  }
}
.operation-wrap {
  display: flex;
  justify-content: space-around;
  color: @color-text;
  .opration-item {
    cursor: pointer;
  }
}
.dialog-body-wrap {
  text-align: center;
}
/deep/.el-table__row {
  height: 200px;
}
</style>
